import axios from 'axios';
import { setAlert } from './alert';
import {
    REGISTER_SUCCESS,
    REGISTER_FAIL,
    FORGOTPASSWORD_SUCCESS,
    FORGOTPASSWORD_FAIL,
    RESETPASSWORD_SUCCESS,
    RESETPASSWORD_FAIL,
    VERIFYEMAIL_SUCCESS,
    VERIFYEMAIL_FAIL,
    USER_LOADED,
    USERS_LOADED,
    AUTH_ERROR,
    LOGIN_SUCCESS,
    LOGIN_FAIL,
    LOGOUT,
    CLEAR_PROFILE,
    UPDATE_AVATAR,
    UPDATE_ERROR,
    USER_ROLE_UPDATED,
    REFERRAL_LINK_GENERATED,
    REFERRAL_LINK_FAIL,
} from './types';
import setAuthToken from '../utils/setAuthToken';

//Get all users
export const getAllUsers = () => async (dispatch) => {
    try {
        const res = await axios.get('/api/users/edit');
        //res.data.avatar = await axios.get('/api/artists/my-avatar');

        dispatch({
            type: USERS_LOADED,
            payload: res.data,
        });
    } catch (err) {
        dispatch({
            type: AUTH_ERROR,
        });
    }
};

//Load User
export const loadUser = () => async (dispatch) => {
    if (localStorage.token) {
        setAuthToken(localStorage.token);
    }

    try {
        const res = await axios.get('/api/auth');
        //console.log('user res', res);
        //res.data.avatar = await axios.get('/api/artists/my-avatar');

        dispatch({
            type: USER_LOADED,
            payload: res.data,
        });
    } catch (err) {
        try {
            const status = err?.response?.status;
            const data = err?.response?.data;
            const reasonByCode = {
                NO_TOKEN: 'auth token was missing from the request',
                TOKEN_EXPIRED: 'auth token is expired',
                TOKEN_INVALID: 'auth token is invalid',
            };
            const hadLocalToken = !!localStorage.token;
            const reason =
                reasonByCode[data?.code] ||
                (hadLocalToken
                    ? 'auth token present locally but rejected by server'
                    : 'no auth token stored in this browser');
            console.warn(
                `[loadUser] failed – ${status} – ${reason}`,
                {
                    code: data?.code,
                    expiredAt: data?.expiredAt,
                    msg: data?.msg,
                } || err?.message
            );
        } catch (_) {}
        dispatch({
            type: AUTH_ERROR,
        });
    }
};

//Register User
export const register =
    ({
        firstName,
        lastName,
        name,
        email,
        password,
        referralKey,
        website,
        formDurationMs,
        challenge,
        eventInvite,
    }) =>
    async (dispatch) => {
        const config = {
            headers: {
                'Content-Type': 'application/json',
            },
        };
        console.log('register', firstName, lastName, name, email);

        let firstNameTrimmed = firstName.trim();
        let lastNameTrimmed = lastName.trim();

        const body = JSON.stringify({
            firstName: firstNameTrimmed,
            lastName: lastNameTrimmed,
            name,
            email,
            password,
            referralKey,
            website, // honeypot
            formDurationMs, // client-side timing hint
            challenge, // delayed JS-initialized value
            eventInvite,
        });

        // console.log('body', body);

        try {
            const res = await axios.post('/api/users', body, config);

            dispatch({
                type: REGISTER_SUCCESS,
                payload: res.data,
            });
            // Ensure subsequent requests have the token immediately
            if (res?.data?.token) {
                try {
                    setAuthToken(res.data.token);
                    // console.log(
                    //     '[register] setAuthToken applied. header now set:',
                    //     !!axios.defaults.headers.common['x-auth-token']
                    // );
                } catch (_) {}
            }

            dispatch(loadUser());
        } catch (err) {
            const errors = err?.response?.data?.errors;
            try {
                console.warn(
                    '[register] failed',
                    err?.response?.status,
                    err?.response?.data || err?.message
                );
            } catch (_) {}

            if (errors) {
                errors.forEach((error) =>
                    dispatch(setAlert(error.msg, 'danger'))
                );
            }
            dispatch({ type: REGISTER_FAIL });
        }
    };

//Generate Referral
export const generateReferral = () => async (dispatch) => {
    //console.log('generateReferral');
    const config = {
        headers: {
            'Content-Type': 'application/json',
        },
    };

    const body = JSON.stringify({ setToRole: 'ARTIST' });

    try {
        const res = await axios.post(
            '/api/users/create-referral',
            body,
            config
        );

        dispatch({
            type: REFERRAL_LINK_GENERATED,
            payload: res.data,
        });
    } catch (err) {
        const errors = err.response.data.errors;

        if (errors) {
            errors.forEach((error) => dispatch(setAlert(error.msg, 'danger')));
        }
        dispatch({ type: REFERRAL_LINK_FAIL });
    }
};

//Forgot Password
export const forgotPassword =
    ({ email }) =>
    async (dispatch) => {
        const config = {
            headers: {
                'Content-Type': 'application/json',
            },
        };

        const body = JSON.stringify({ email });

        try {
            const res = await axios.put(
                '/api/users/forgot-password',
                body,
                config
            );
            dispatch({
                type: FORGOTPASSWORD_SUCCESS,
                payload: res.data,
            });
            dispatch(setAlert(res.data, 'success'));
            return 'Verification Email Sent';
            //console.log('res.data: ' + res.data);
            // dispatch(setAlert(error.msg, 'success'));
        } catch (err) {
            //const errors = err.response.data.errors;
            //console.log('err: ' + err);
            // if (errors) {
            //   errors.forEach((error) => dispatch(setAlert(error.msg, 'danger')));
            // }
            dispatch(setAlert(err.message, 'danger'));
            dispatch({
                type: FORGOTPASSWORD_FAIL,
                errors: err.message,
                rawErr: err,
                email: email,
            });
        }
    };

//Reset Password
export const resetPassword =
    ({ newPass, resetLink }) =>
    async (dispatch) => {
        const config = {
            headers: {
                'Content-Type': 'application/json',
            },
        };

        const body = JSON.stringify({ newPass, resetLink });

        try {
            const res = await axios.put(
                '/api/users/reset-password',
                body,
                config
            );

            dispatch({
                type: RESETPASSWORD_SUCCESS,
                payload: res.data,
            });
        } catch (err) {
            const errors = err?.response?.data?.errors;
            const singleError = err?.response?.data?.error;
            if (errors && Array.isArray(errors) && errors.length > 0) {
                errors.forEach((error) =>
                    dispatch(
                        setAlert(
                            error.msg ||
                                error.error ||
                                'Could not reset password.',
                            'danger'
                        )
                    )
                );
            } else if (singleError) {
                dispatch(setAlert(singleError, 'danger'));
            } else if (err?.response?.status === 401) {
                dispatch(
                    setAlert(
                        'Reset link is invalid or expired. Please request a new reset email.',
                        'danger'
                    )
                );
            } else {
                dispatch(
                    setAlert(
                        'Could not reset password. Please try again.',
                        'danger'
                    )
                );
            }
            dispatch({ type: RESETPASSWORD_FAIL });
        }
    };

//Update User Avatar
export const updateUserAvatar = (formData, history) => async (dispatch) => {
    try {
        const config = {
            headers: {
                'Content-Type': 'application/json',
            },
        };
        const res = await axios.put(
            '/api/users/update-avatar',
            formData,
            config
        );

        dispatch({
            type: UPDATE_AVATAR,
            payload: res.data.avatar,
        });

        dispatch(setAlert('User Avatar Updated', 'success')); // alertType = 'success' to add a class of alert-success to the alert (alert.alertType used in /components/layout/Alert.js)
    } catch (err) {
        const errors = err.response.data.errors;

        if (errors) {
            errors.forEach((error) => dispatch(setAlert(error.msg, 'danger')));
        }
        dispatch({
            type: UPDATE_ERROR,
            payload: {
                msg: err.response.statusText,
                status: err.response.status,
            },
        });
    }
};

//Update User Role
export const updateUserRole = (formData, history) => async (dispatch) => {
    try {
        const config = {
            headers: {
                'Content-Type': 'application/json',
            },
        };
        //console.log('updateUserRole');
        const res = await axios.put('/api/users/update-role', formData, config);

        dispatch({
            type: USER_ROLE_UPDATED,
            payload: res.data,
        });

        dispatch(setAlert('User Role Updated', 'success')); // alertType = 'success' to add a class of alert-success to the alert (alert.alertType used in /components/layout/Alert.js)
    } catch (err) {
        const errors = err.response.data.errors;

        if (errors) {
            errors.forEach((error) => dispatch(setAlert(error.msg, 'danger')));
        }
        dispatch({
            type: UPDATE_ERROR,
            payload: {
                msg: err.response.statusText,
                status: err.response.status,
            },
        });
    }
};

//Login User
export const login = (email, password) => async (dispatch) => {
    const config = {
        headers: {
            'Content-Type': 'application/json',
        },
    };

    const body = JSON.stringify({ email, password });

    try {
        const res = await axios.post('/api/auth', body, config);

        dispatch({
            type: LOGIN_SUCCESS,
            payload: res.data,
        });
        dispatch(loadUser());
    } catch (err) {
        const errors = err.response.data.errors;

        if (errors) {
            errors.forEach((error) => dispatch(setAlert(error.msg, 'danger')));
        }
        dispatch({ type: LOGIN_FAIL });
    }
};

// Logout / Clear Profile
export const logout = () => (dispatch) => {
    setAuthToken();
    dispatch({
        type: CLEAR_PROFILE,
    });
    dispatch({
        type: LOGOUT,
    });
};

// Verify Email via magic link
// Returns the server response data (truthy) on success — may include an
// `rsvp` object when the link also completed an RSVP — or false on failure.
export const verifyEmail = (token) => async (dispatch) => {
    try {
        const res = await axios.get(
            `/api/users/verify-email?token=${encodeURIComponent(token)}`
        );
        dispatch({ type: VERIFYEMAIL_SUCCESS, payload: res.data });
        dispatch(setAlert('Thank you for verifying your email!', 'success'));
        return res.data || true;
    } catch (err) {
        dispatch({ type: VERIFYEMAIL_FAIL });
        dispatch(
            setAlert('Verification link is invalid or expired.', 'danger')
        );
        return false;
    }
};

// Resend verification email
export const resendVerificationEmail =
    (options = {}) =>
    async (dispatch) => {
        try {
            const payload =
                options && typeof options === 'object'
                    ? {
                          ...(typeof options.nonce === 'string'
                              ? { nonce: options.nonce }
                              : {}),
                          ...(typeof options.returnTo === 'string'
                              ? { returnTo: options.returnTo }
                              : {}),
                          ...(options.rsvp && typeof options.rsvp === 'object'
                              ? { rsvp: options.rsvp }
                              : {}),
                      }
                    : {};
            // DEBUG: always log for now
            console.log('[resendVerificationEmail] sending payload', payload);
            await axios.post('/api/users/resend-verification', payload);
            dispatch(setAlert('Verification email sent.', 'success'));
            return true;
        } catch (err) {
            // DEBUG: always log for now
            console.log(
                '[resendVerificationEmail] failed to send payload',
                options,
                err?.response?.data || err?.message
            );
            dispatch(setAlert('Could not send verification email.', 'danger'));
            return false;
        }
    };
